"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Settings = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0z", fill: fill || 'currentColor' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.903 2.379a1 1 0 0 0-.94.093l-1.407.942a1 1 0 0 1-1.113 0l-1.407-.942a1 1 0 0 0-.94-.093l-1.847.765a1 1 0 0 0-.598.73l-.33 1.661a1 1 0 0 1-.786.787l-1.661.329a1 1 0 0 0-.73.598l-.766 1.848a1 1 0 0 0 .093.94l.943 1.406a1 1 0 0 1 0 1.113l-.943 1.408a1 1 0 0 0-.093.94l.765 1.847a1 1 0 0 0 .73.598l1.662.329a1 1 0 0 1 .787.787l.329 1.661a1 1 0 0 0 .598.73l1.848.766a1 1 0 0 0 .939-.093l1.407-.943a1 1 0 0 1 1.113 0l1.407.943a1 1 0 0 0 .94.093l1.847-.766a1 1 0 0 0 .599-.73l.328-1.661a1 1 0 0 1 .787-.787l1.662-.329a1 1 0 0 0 .73-.598l.765-1.848a1 1 0 0 0-.093-.939l-.942-1.407a1 1 0 0 1 0-1.113l.942-1.408a1 1 0 0 0 .093-.939l-.765-1.848a1 1 0 0 0-.73-.598l-1.662-.329a1 1 0 0 1-.787-.786l-.328-1.662a1 1 0 0 0-.599-.73l-1.847-.765zm-1.234 2.697.963-.645.859.356.224 1.137a3 3 0 0 0 2.361 2.36l1.137.225.355.86-.644.962a3 3 0 0 0 0 3.338l.645.963-.356.859-1.137.225a3 3 0 0 0-2.36 2.36l-.225 1.137-.86.356-.962-.645a3 3 0 0 0-3.339 0l-.962.645-.86-.356-.224-1.136a3 3 0 0 0-2.36-2.361l-1.138-.225-.355-.859.645-.963a3 3 0 0 0 0-3.338l-.645-.963.356-.859 1.136-.225a3 3 0 0 0 2.36-2.36l.226-1.137.859-.356.962.645a3 3 0 0 0 3.339 0z", fill: fill || 'currentColor' })));
};
exports.default = Settings;
